// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"UploadFromFile_buttonsContainer__SiKlx"};